export const QUESTION_PAGE = 0;
export const PHOTO_PAGE = 1;
export const MAP_PAGE = 2;
export const SCORE_PAGE = 3;
